import { FieldFile, FieldFileCommonTypes } from 'components/GeneralFormView/FormField/types';
import {
  BaseFormViewModel,
} from '../../types';
import { PrizeDTO } from './prizeDTO';

export enum PrizeType {
  points = "points",
  WIFI_PACKAGE = "WIFI_PACKAGE",
  physical = "physical",
  yango_promo_code = "yango_promo_code",
}
export interface PrizeToUpdate {
  value?: string | number;
  isActive: boolean;
  type: PrizeType;
  textImage?: string;
}
export class PrizeFormViewModel extends BaseFormViewModel<PrizeDTO> {
  prizeId: number;
  value?: number;
  title?: string;
  weight: number;
  isActive: boolean;
  backgroundColor: string;
  backgroundImageUrl: string;
  maxWinners: number;
  type: PrizeType[];
  wifiPackageId?: number[];
  promoCodeGroupId?: number[];
  textImage: FieldFile[];

  constructor(dto: PrizeDTO) {
    super();
    const {
      prizeId,
      value,
      weight,
      isActive,
      backgroundColor,
      backgroundImageUrl,
      maxWinners,
      type,
      prizeWifi,
      textImage,
    } = dto;
    const viewObject: {
      [key: string]:
        | string
        | number
        | number[]
        | PrizeType[]
        | boolean
        | FieldFile[];
    } = {
      prizeId: prizeId || 0,
      weight,
      isActive,
      backgroundColor,
      backgroundImageUrl,
      maxWinners,
      type: type ? [type] : [],
      wifiPackageId: prizeWifi?.wifiPackageId ? [prizeWifi.wifiPackageId] : [],

      textImage: textImage
        ? [
            {
              source: textImage,
              type: FieldFileCommonTypes.IMAGE,
            },
          ]
        : [],
    };
    if (
      [
        PrizeType.WIFI_PACKAGE,
        PrizeType.physical,
        PrizeType.yango_promo_code,
      ].includes(type)
    ) {
      viewObject.title = value;
    } else {
      viewObject.value = value;
    }
    Object.assign(this, viewObject);
  }

  toDTO() {
    return {} as PrizeDTO;
  }
}
